/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataRestoreInfo.tpl.html';

angular
  .module('batch.metadataRestore.info', ['ngSanitize', 'services.view'])
  /**
   * Controller for the metadatarestore.info template.
   */
  .controller(
    'MetadataRestoreInfoCtrl',
    function (
      $scope,
      $filter,
      $state,
      $window,
      batchUtils,
      UserAgentFactory,
      progressFactory,
      ALERT_EVENTS,
      VIEW_STATES,
      lastState,
      viewUtils
    ) {
      var batchDate, sourceBatchDate;

      /**
       * Utility function for returning to the previous state.
       */
      $scope.goBack = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.LOG_HOME);
      };

      /**
       * Set the scope properties.
       */
      function updateInfo() {
        var jobType = $scope.batchUtils.currentBatch.type,
          objectsComplete =
            ($scope.batchUtils.currentBatch.metadataRestoreData &&
              $scope.batchUtils.currentBatch.metadataRestoreData.objectsComplete) ||
            0,
          totalObjects =
            ($scope.batchUtils.currentBatch.metadataRestoreData &&
              $scope.batchUtils.currentBatch.metadataRestoreData.totalObjects) ||
            0,
          percentComplete = totalObjects > 0 ? Math.ceil((objectsComplete / totalObjects) * 100) : 0,
          numErrors = totalObjects - objectsComplete,
          errorText = numErrors === 1 ? $filter('i18n')('ERROR') : $filter('i18n')('ERRORS');
        $scope.boinkCls =
          $scope.batchUtils.currentBatch.status && batchUtils.STATUS[$scope.batchUtils.currentBatch.status]
            ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].bigBoinkCls
            : '';

        batchDate = moment($scope.batchUtils.currentBatch.date);
        sourceBatchDate = moment(
          ($scope.batchUtils.currentBatch.metadataRestoreData &&
            $scope.batchUtils.currentBatch.metadataRestoreData.sourceBatchDate) ||
            0
        );

        if (sourceBatchDate) {
          $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE_METADATA_RESTORE', [
            batchDate.format(SBSF.messages.M_D_Y),
            batchDate.format(SBSF.messages.H_M),
            $filter('i18n')(jobType),
            $filter('i18n')('ITEMS_RESTORED_FROM', [
              objectsComplete,
              totalObjects,
              sourceBatchDate.format(SBSF.messages.M_D_Y_H_M)
            ])
          ]);
        } else {
          $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE_METADATA_RESTORE', [
            batchDate.format(SBSF.messages.M_D_Y),
            batchDate.format(SBSF.messages.H_M),
            $filter('i18n')(jobType),
            $filter('i18n')('ITEMS_RESTORED', [objectsComplete, totalObjects])
          ]);
        }

        $scope.pctCls = function () {
          return $scope.batchUtils.currentBatch.status
            ? batchUtils.STATUS[$scope.batchUtils.currentBatch.status].textCls
            : '';
        };

        if (
          $scope.batchUtils.currentBatch.metadataRestoreData &&
          $scope.batchUtils.currentBatch.metadataRestoreData.metadataCompareBatchDate
        ) {
          var compareBatchDate = moment($scope.batchUtils.currentBatch.metadataRestoreData.metadataCompareBatchDate);
          $scope.userEmailStr = $filter('i18n')('RESTORE_BY_FROM_COMPARE', [
            $scope.batchUtils.currentBatch.metadataRestoreData.userEmail,
            compareBatchDate.format(SBSF.messages.M_D_Y_H_M)
          ]);
        } else {
          $scope.userEmailStr = $filter('i18n')(
            'RESTORE_BY',
            $scope.batchUtils.currentBatch.metadataRestoreData &&
              $scope.batchUtils.currentBatch.metadataRestoreData.userEmail
          );
        }
        $scope.percentCompleteStr = $filter('i18n')('PERCENT_COMPLETE', [percentComplete, numErrors, errorText]);
      }

      // If a currentBatch is empty set redirect app to the admin view.
      if (_.isEmpty($scope.batchUtils.currentBatch)) {
        $scope.goBack();
      } else {
        updateInfo();
      }

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };
    }
  );
